import { useCallback, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import MediaService from '../../services/MediaService'
import UnitNavigation from '../../components/Navigation/UnitNavigation'
import Surprise from '../../components/World/Surprise/Surprise'
import { GetUserVideo, getVideo } from '../../s3Func/s3Download'

const Module2Nav = () => {
	const { module2 } = useSelector((state) => state.module2, shallowEqual)
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	/*****************************
	 * BG Image Logic
	 ******************************/

	const [bgImage, setBgImage] = useState('')
	const [displaySurprise, setDisplaySurprise] = useState(false)
	const [surpriseConfig, setSurpriseConfig] = useState(null)

	const checkScreenSize = useCallback(
		(el) => {
			const desktopImage =
				'/Module2Images/Module2NavImages/U1M2_JourneyMap_Landscape.png'
			const mobileImage = '/Module2Images/Module2NavImages/M2_Path_Mobile.png'

			el.screen && el.screen.width < 1025
				? setBgImage(mobileImage)
				: setBgImage(desktopImage)
		},
		[setBgImage]
	)

	const resizeListener = useCallback(() => {
		window.addEventListener(
			'resize',
			(event) => checkScreenSize(event.target),
			true
		)
	}, [checkScreenSize])

	useEffect(() => {
		checkScreenSize(window)
		resizeListener()
	})

	const backgroundPath = bgImage && MediaService.getImage(bgImage, login)
	const worldBG = MediaService.getImage(
		'/Module2Images/Module2NavImages/U1M2_JourneyMap_Landscape.png',
		login
	)

	/*****************
	 *  Day Logic
	 * ***************/

	const getDayConfig = useCallback((dayNumber) => {
		let filledImageUrl = `/Module2Images/Module2NavImages/Color_Day${dayNumber}.png`
		let outlinedImageUrl = `/Module2Images/Module2NavImages/Outline_Day${dayNumber}.png`

		// Use the trophy image from module1
		if (dayNumber === 9) {
			outlinedImageUrl = '/Module1Images/Module1NavImages/Outline_Day9.png'
			filledImageUrl = '/Module1Images/Module1NavImages/Color_Day9.png'
		}

		return {
			dayNumber,
			destiny: '/listening',
			filledImageUrl,
			outlinedImageUrl,
		}
	}, [])

	const daysArray = [...Array(9).keys()]
	const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1))

	const SURPRISE_VIDEO = {
		video: '46bd04df8bf8e01c34daf3644c31/480.m3u8',
		song: 'appfiles/listening/listening_student_instrumental.m4a',
		slides: [
			`influencers/${login.influencerid}/answer_affirmation.mp4`,
			`userfiles/${module2.StudentID}/listening_celebration_surprise_6.mp4`,
			`userfiles/${module2.StudentID}/listening_smile.jpg`,
			`influencers/${login.influencerid}/listening_video_message.mp4`,
			`userfiles/${module2.StudentID}/listening_celebration_surprise_8.mp4`,
			`userfiles/${module2.StudentID}/listening_silly_photo_2.jpg`,
			`userfiles/${module2.StudentID}/listening_celebration_surprise_9.mp4`,
		],
	}

	const handleSurpriseClick = async () => {
		let { slides, song, video } = SURPRISE_VIDEO

		slides = await Promise.all(
			slides.map(async (url) => await GetUserVideo(url, login))
		)
		song = getVideo(song, login)

		setSurpriseConfig({ video, slides, song })
		setDisplaySurprise(true)
	}

	/*****************************
	 *  Component configuration
	 * ***************************/

	return (
		<>
			{displaySurprise && (
				<Surprise
					background={worldBG}
					setDisplaySurprise={setDisplaySurprise}
					video={surpriseConfig.video}
					song={surpriseConfig.song}
					slides={surpriseConfig.slides}
					onSurpriseEnded={() => setDisplaySurprise(false)}
				/>
			)}

			<UnitNavigation
				moduleName="MODULE2"
				module={module2}
				days={DAYS_CONFIG}
				totalDays={9}
				unitDestiny="/unit1"
				nextDestiny="/unit1"
				backgroundPath={backgroundPath}
				onSurpriseClick={handleSurpriseClick}
				unit={1}
				animal={MediaService.getImage('/Images/Button_DogHead.png', login)}
			/>
		</>
	)
}
export default Module2Nav
